import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const textClass = scrolled ? "text-foreground-800" : "text-white";
  const textHoverClass = scrolled ? "hover:text-primary-500" : "hover:text-white/80";
  const logoMainClass = scrolled ? "text-foreground-900" : "text-white";
  const logoAccentClass = scrolled ? "text-primary-500" : "text-primary-300";
  const hamburgerClass = scrolled ? "text-foreground-800" : "text-white";
  const hamburgerBgClass = scrolled ? "hover:bg-background-100" : "hover:bg-white/10";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/98 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className={`text-xl font-heading font-semibold transition-colors duration-200 ${logoMainClass} group-hover:text-primary-500`}>
              USFans <span className={`transition-colors duration-200 ${logoAccentClass}`}>Wiki</span>
            </span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${textClass} ${textHoverClass}`}
            >
              Strona główna
            </Link>
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${textClass} ${textHoverClass}`}
            >
              USFans Spreadsheet
            </a>
            <Link
              to="/artykul/usfans-spreadsheet-kompletny-przewodnik-2026"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${textClass} ${textHoverClass}`}
            >
              Poradnik
            </Link>
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${textClass} ${textHoverClass}`}
            >
              Poradnik zakupowy
            </a>
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              Kup Teraz
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-200 ${hamburgerBgClass}`}
            aria-label="Menu"
          >
            <i className={`text-xl ${hamburgerClass} ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 py-2"
            >
              Strona główna
            </Link>
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 py-2"
            >
              USFans Spreadsheet
            </a>
            <Link
              to="/artykul/usfans-spreadsheet-kompletny-przewodnik-2026"
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 py-2 whitespace-nowrap"
            >
              Poradnik
            </Link>
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 py-2"
            >
              Poradnik zakupowy
            </a>
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="inline-flex items-center justify-center px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200"
            >
              Kup Teraz
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}